import React from 'react';

const StudentFacultyLogin = () => {
  return (
    <div>
      StudentFacultyLogin
      StudentFacultyLogin
    </div>
  );
}

export default StudentFacultyLogin;
